import React, { memo } from 'react';
export const TrustBar = memo(function TrustBar() {
  const trustItems = [{
    icon: '⚡',
    text: 'Normativa AEA Incluida'
  }, {
    icon: '🇦🇷',
    text: '100% Contenido Argentino'
  }, {
    icon: '📄',
    text: 'PDF Descargable Instantáneo'
  }, {
    icon: '🔒',
    text: 'Garantía 30 Días'
  }, {
    icon: '⏱️',
    text: 'Acceso de por Vida'
  }];
  return;
});